import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import firebase from "../../../firebase";

import {
    StyledModal,
    StyledModalTitle,
    StyledModalDescription,
    StyledPaper,
    DownloadButton,
    CancelButton,
    StyledLottie,
} from "../styles/Mainpage-styled.js";

import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CancelIcon from "@material-ui/icons/Cancel";

import animationData from "../../../assets/lottie/LastScene/sticker_share.json";

const SliderModal = ({
    open,
    handleClose,
    storeURL,
    nameRestaurant,
    isIOS,
    isAndroid,
}) => {
    const [phoneType] = useState(
        isIOS ? "ios" : isAndroid ? "android" : "unknown"
    );
    const { t } = useTranslation();

    const analytics = firebase.analytics();

    const handleClickDownloadButton = () => {
        if (nameRestaurant !== null) {
            analytics.logEvent("web_click_download", {
                name: nameRestaurant,
                deviceOS: phoneType,
            });
            console.log("analytic yes! ", nameRestaurant, phoneType);
        } else {
            analytics.logEvent("web_click_download", {
                name: "no_id",
                deviceOS: phoneType,
            });
            console.log("analytic yes! no_id", phoneType);
        }
    };

    return (
        <StyledModal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
        >
            <Fade in={open} timeout={0}>
                <StyledPaper>
                    <CancelButton onClick={handleClose} aria-label="Cancel">
                        <CancelIcon />
                    </CancelButton>
                    <StyledModalTitle id="transition-modal-title">
                        {t("mainPage.text.modalHeader", "Want to play more?")}
                    </StyledModalTitle>
                    <StyledModalDescription id="transition-modal-descriStyledModalDescriptiontion">
                        {t(
                            "mainPage.text.modalDescription",
                            "Join an adventure that gets everyone smiling and sharing!"
                        )}
                    </StyledModalDescription>
                    <StyledLottie
                        loop
                        play
                        animationData={animationData}
                        rendererSettings={{
                            preserveAspectRatio: "xMidYMid slice",
                        }}
                    />
                    <DownloadButton
                        onClick={handleClickDownloadButton}
                        href={storeURL}
                    >
                        {t(
                            "mainPage.button.modalDownloadButton",
                            "Download App"
                        )}
                    </DownloadButton>
                </StyledPaper>
            </Fade>
        </StyledModal>
    );
};

export default SliderModal;
